export const BASIC_AUTH_TOKKEN = "basicAuthToken";
export const ACCESS_TOKKEN = "accessToken";

export const ACCESS_TOKKEN_EXPIRED = "token expired";

export const MESSAGE_KEY = "messageKey";
export const SESSION_ID = "sessionId";
export const REMEMBER_USER_NAME = "rememberUserName";
export const REMEMBER_ME_CHECKBOX = "rememberMe";

export const LOGIN_ID = "loginId";
export const USER_ID = "userId";
export const IS_EXTERNAL_USER = "isExternalUser";
export const COMPANY_CODE = "companyCode";
export const COMPANY_NAME = "companyName";
export const COMPANY_ID = "companyId";


export const USER_NAME = "userName";
export const USER_ROLE = "userRole";

export const LOGIN_RESPONSE = "userDetails";
export const NAV_PAYOUT_DETAIL_DATA = "navPayoutDetailData";
export const NAV_PAYOUT_ALL_TRANSACTION_DETAIL_DATA =
  "navPayoutAllTransactionDetailData";

export const NAV_ONHOLD_DETAILS = "onHoldDetails";
export const NAV_ONHOLD_ALL_TRANSACTIONS = "onHoldAllTransactions";
export const SELECTED_ON_HOLD_CYCLE = "selectedOnHoldCycle";
export const SELECTED_ON_HOLD_TRANSACTION_TYPE = "selectedOnHoldTransactionType";
export const SELECTED_ON_HOLD_COMPANY = "selectedOnHoldCompany";
export const SELECTED_ON_HOLD_ALL_TRANSACTIONS= "selectedOnHoldAllTransactions";

export const SELECTED_PAYOUT_CYCLE = "selectedPayoutCycle";
export const SELECTED_TRANSACTION_TYPE = "selectedTransactionType";
export const SELECTED_COMPANY = "selectedCompany";
export const SELECTED_PAYOUT_DEALER_DATA = "selectedPayoutDealerData";
export const SELECTED_PAYOUT_CYCLE_DATA = "selectedPayoutCycleData";

export const SELECTED_DEALER_TYPE = "selecteddealerType";
export const SELECTED_ALL_TRANSACTION = "selectedAllTransaction";
export const SELECTED_TRANSACTION_DETAILS = "selectedTransactionDetails";

export const AWAITING_FILE_DOWNLOAD = "awaitingDownload";
export const FAILED_DOWNLOADED_FILES = "failedDownloadedFiles";
export const ALREADY_DOWNLOADED_FILES = "alreadyDownloadedFiles";
